const apiUrl = process.env.REACT_APP_API_URL;

export const GetConjuntPildoresCaza = async (idConjunt: string, userId: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/pildores/${idConjunt}/caza`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: userId })
        });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener las pildores del conjunt:', error);
        return [];
    }
};
